<template>
  <div>
    <a :href="url" target="_blank">
      <div class="box">
        <span>
          <b-icon v-if="icon" :icon="icon"/>
        </span>
        <span class="subtitle has-text-weight-bold" style="margin-left: 2rem">{{ name }}</span>

      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: false,
      type: String
    },
    url: {
      required: false,
      type: String
    },
    icon: {
      required: false,
      type: String
    }
  }
}
</script>

<style scoped>

</style>
